
import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function CoverageCTA() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.15 });

  return (
    <section ref={ref} className="py-16 sm:py-24 px-4 sm:px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div
          className={`relative bg-gradient-to-br from-navy via-navy-light to-[#2A4A6B] rounded-2xl sm:rounded-3xl p-8 sm:p-12 lg:p-16 text-center overflow-hidden transition-all duration-700 ${
            isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
          }`}
        >
          {/* Decorative */}
          <div className="absolute top-0 right-0 w-40 h-40 bg-white/[0.04] rounded-full -translate-y-1/2 translate-x-1/2"></div>
          <div className="absolute bottom-0 left-0 w-56 h-56 bg-white/[0.03] rounded-full translate-y-1/3 -translate-x-1/3"></div>

          <div className="relative z-10">
            <div className="w-14 h-14 mx-auto mb-6 bg-white/10 rounded-2xl flex items-center justify-center">
              <i className="ri-map-pin-line text-white text-2xl"></i>
            </div>
            <h2 className="text-white text-[24px] sm:text-[30px] lg:text-[36px] font-semibold mb-4">
              Need Coverage in Your Area?
            </h2>
            <p className="text-white/75 text-base sm:text-lg mb-8 max-w-xl mx-auto leading-relaxed">
              Whether you&apos;re a hospital, physician group, or imaging center — contact us to discuss mobile imaging deployment at your facility anywhere in California.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/contact"
                className="px-10 py-4 bg-white text-navy rounded-full font-semibold text-[15px] hover:shadow-2xl hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Request a Quote
              </Link>
              <a
                href="tel:+18005551234"
                className="flex items-center gap-2 px-8 py-4 border-2 border-white/25 text-white rounded-full font-medium text-[15px] hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-base"></i>
                </span>
                Call Us Today
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
